// Akordeony: [data-accordion-item] > [data-accordion-toggle] + [data-accordion-content]
// [data-accordion-group] — w grupie otwarty jest jeden element naraz.
// Po zmianie stanu element emituje zdarzenie "accordion:toggle" (detail.open).
function setState(sectionElement, open) {
    const contentElement = sectionElement.querySelector('[data-accordion-content]'),
        toggleElement = sectionElement.querySelector('[data-accordion-toggle]');

    sectionElement.classList.toggle('active', open);

    // przejście startuje od bieżącej wysokości (także gdy panel był otwarty bez limitu)
    contentElement.style.maxHeight = contentElement.scrollHeight + 'px';
    if (!open) {
        contentElement.getBoundingClientRect();
        contentElement.style.maxHeight = '0px';
    }

    if (toggleElement) {
        toggleElement.setAttribute('aria-expanded', open);
    }
    sectionElement.dispatchEvent(new CustomEvent('accordion:toggle', {bubbles: true, detail: {open}}));
}

function init() {

    const toggleList = document.querySelectorAll('[data-accordion-toggle]');

    toggleList.forEach((element) => {

        // [data-accordion-item] pozwala umieścić przycisk np. w nagłówku (FAQ, kolumny stopki)
        const sectionElement = element.closest('[data-accordion-item]') || element.parentNode,
            contentElement = sectionElement.querySelector('[data-accordion-content]');

        if (!contentElement) {
            return;
        }

        // otwarty panel nie ma limitu wysokości — treść może urosnąć (formularz, obrót ekranu)
        contentElement.addEventListener('transitionend', (event) => {
            if (event.target === contentElement && event.propertyName === 'max-height'
                && sectionElement.classList.contains('active')) {
                contentElement.style.maxHeight = 'none';
            }
        });

        element.addEventListener('click', () => {
            const open = !sectionElement.classList.contains('active'),
                group = sectionElement.closest('[data-accordion-group]');

            if (open && group) {
                group.querySelectorAll('[data-accordion-item].active').forEach((item) => {
                    if (item !== sectionElement) {
                        setState(item, false);
                    }
                });
            }

            setState(sectionElement, open);
        });
    });
};

export default {init};
